import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "dahmani-cookie-consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 inset-x-0 z-[60] bg-[#06152d] text-white border-t border-[#d4af37]/30 px-6 py-4">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-white/80 leading-relaxed text-center sm:text-left">
          Questo sito utilizza solo cookie tecnici necessari al funzionamento. Nessun cookie di profilazione di terze parti.{" "}
          <Link to="/cookie-policy" data-testid="cookie-banner-link" className="underline text-[#d4af37] hover:text-white transition-colors">
            Leggi la Cookie Policy
          </Link>
        </p>
        <button
          data-testid="cookie-accept-btn"
          onClick={accept}
          className="shrink-0 px-6 py-2.5 rounded-full bg-[#d4af37] text-[#06152d] text-xs font-bold uppercase tracking-wider hover:bg-white transition-colors"
        >
          Accetta
        </button>
      </div>
    </div>
  );
}
